import { render, staticRenderFns } from "./Workgroups.vue?vue&type=template&id=64be180b&"
import script from "./Workgroups.vue?vue&type=script&lang=js&"
export * from "./Workgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports